interface FieldLabelProps {
  children?: React.ReactNode;
  required?: boolean;
}

/**
 * Column heading for the repeating-row sections. It names a whole column rather
 * than one control, so it is not a `<label>` and carries no `htmlFor`.
 */
export function FieldLabel(props: FieldLabelProps) {
  const { children, required } = props;

  return (
    <p className="text-xs text-muted-foreground">
      {children}
      {required && <span className="text-destructive">*</span>}
    </p>
  );
}
